/* LILY-TRACK v2  (14 sep 2026)
   First-party gedragstracking voor de hele winkel -> eigen collector op Hetzner.
   Vervangt lily-gallery-track.js (v1) en breidt die uit. ES5, geen afhankelijkheden.

   Waarom: v1 vuurde gallery_depth ALLEEN als de bezoeker de galerij aanraakte.
   Wie landde, las en wegging vuurde niets, dus verblijftijd en bounce waren
   onmeetbaar. v2 vuurt page_exit ALTIJD.

   Events:
     page_view       elke paginaweergave. meta: template, referrer, apparaat,
                     viewport, in-app browser, verbinding, nieuw/terugkerend
     perf            laadtijden uit Navigation Timing + LCP. eenmaal per pagina
     element_click   elke klik op iets klikbaars, met rol-gok en positie
     variant_change  gekozen variant op de PDP
     gallery_interact  eerste aanraking van de fotogalerij  (zelfde als v1)
     gallery_depth     hoogste fotoindex bij verlaten       (zelfde als v1)
     page_exit       ALTIJD bij verlaten. meta: verblijftijd, scrolldiepte,
                     aantal klikken, rage clicks, dode klikken, laatste element

   Config komt uit window.LILYCFG (inline gezet in layout/theme.liquid).
   Uitzetten? Haal de twee regels LILY-TRACK uit layout/theme.liquid.
*/
(function () {
  'use strict';

  var CFG = window.LILYCFG || {};
  var SHOP = CFG.shop;
  if (!SHOP) return;
  if (window.__lilyTrackOn) return;
  window.__lilyTrackOn = true;

  var ENDPOINT = 'https://pixel.178.104.12.53.sslip.io/pixel/collect';
  var MAX_CLICKS = 30;          // klikgebeurtenissen per pagina
  var SESSION_MIN = 30;         // sessie verloopt na 30 minuten stilte

  function safe(fn) { try { return fn(); } catch (e) { return null; } }

  /* ---------- identiteit ---------------------------------------------- */

  // clientId: dezelfde waarde als Shopify's web pixel (_shopify_y), zodat alles
  // te koppelen is aan add_to_cart, checkout en order.
  function clientId() {
    return safe(function () {
      var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    });
  }

  // sessieId: eigen sessie met 30-minutenvenster. client_id leeft maanden door,
  // dus zonder dit meet je "17 uur op de site" en dat is onzin.
  var SESS = (function () {
    return safe(function () {
      var now = Date.now();
      var id = localStorage.getItem('lily_sid');
      var last = parseInt(localStorage.getItem('lily_sid_ts') || '0', 10);
      var isNew = false;
      if (!id || !last || (now - last) > SESSION_MIN * 60000) {
        id = (now.toString(36) + Math.random().toString(36).slice(2, 8));
        localStorage.setItem('lily_sid', id);
        isNew = true;
        var seen = parseInt(localStorage.getItem('lily_sessions') || '0', 10);
        localStorage.setItem('lily_sessions', String(seen + 1));
      }
      localStorage.setItem('lily_sid_ts', String(now));
      return { id: id, isNew: isNew, nth: parseInt(localStorage.getItem('lily_sessions') || '1', 10) };
    }) || { id: null, isNew: true, nth: 1 };
  })();

  /* ---------- UTM's ---------------------------------------------------- */
  // Het thema herschrijft location.search naar ?variant=... en collectiepagina's
  // laten de UTM vallen bij doorklikken. Navigation Timing bewaart de originele
  // URL; localStorage draagt hem mee over de collectiepagina heen.
  var UTM = (function () {
    return safe(function () {
      function fromUrl(href) {
        var sp = new URL(href, location.href).searchParams;
        return {
          cp: sp.get('utm_campaign'), c: sp.get('utm_content'),
          s: sp.get('utm_source'), m: sp.get('utm_medium'), fb: sp.get('fbclid')
        };
      }
      var a = fromUrl(location.href);
      if (!a.cp) {
        var nav = (performance.getEntriesByType('navigation') || [])[0];
        if (nav && nav.name) {
          var b = fromUrl(nav.name);
          if (b.cp) a = b;
        }
      }
      var out = {};
      var map = { cp: 'lt_campaign', c: 'lt_content', s: 'lt_source', m: 'lt_medium' };
      for (var k in map) {
        if (a[k]) { localStorage.setItem(map[k], a[k]); out[k] = a[k]; }
        else { out[k] = localStorage.getItem(map[k]); }
      }
      out.fb = a.fb ? 1 : 0;
      return out;
    }) || {};
  })();

  /* ---------- omgeving -------------------------------------------------- */

  var ENV = safe(function () {
    var ua = navigator.userAgent || '';
    var inapp = /FBAN|FBAV|FB_IAB|Instagram|FBIOS/i.test(ua) ? 'meta'
              : /Line\/|TikTok|Snapchat/i.test(ua) ? 'ander-inapp' : 'browser';
    var conn = navigator.connection || {};
    return {
      w: window.innerWidth, h: window.innerHeight,
      dpr: Math.round((window.devicePixelRatio || 1) * 10) / 10,
      mob: (window.innerWidth < 768) ? 1 : 0,
      inapp: inapp,
      ua: ua.slice(0, 180),
      net: conn.effectiveType || null,
      ram: navigator.deviceMemory || null,
      cpu: navigator.hardwareConcurrency || null,
      tz: safe(function () { return Intl.DateTimeFormat().resolvedOptions().timeZone; }),
      ref: safe(function () { return document.referrer ? new URL(document.referrer).host : null; }),
      lang: navigator.language || null
    };
  }) || {};

  /* ---------- verzenden -------------------------------------------------- */

  function envelope(name, meta, index) {
    return {
      shop: SHOP, event: name, clientId: clientId(),
      sessionId: SESS.id, pageType: CFG.tpl || null,
      utm_campaign: UTM.cp || null, utm_content: UTM.c || null,
      url: String(location.href).slice(0, 400),
      productId: CFG.pid || null, productTitle: CFG.ptitle || null,
      price: (typeof index === 'number' ? index : null),
      meta: meta || null
    };
  }

  function post(payload, beacon) {
    safe(function () {
      var body = JSON.stringify(payload);
      if (beacon && navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }));
      } else {
        fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true });
      }
    });
  }

  function send(name, meta, index) { post(envelope(name, meta, index), false); }

  /* ---------- page_view -------------------------------------------------- */

  send('page_view', {
    tpl: CFG.tpl || null,
    path: location.pathname.slice(0, 160),
    ref: ENV.ref, reftype: ENV.ref ? (/facebook|instagram|fb\./i.test(ENV.ref) ? 'meta'
         : /google|bing|duckduck/i.test(ENV.ref) ? 'zoek' : 'ander') : 'direct',
    src: UTM.s || null, med: UTM.m || null, fbclid: UTM.fb,
    newsess: SESS.isNew ? 1 : 0, nthsess: SESS.nth,
    cust: CFG.cust || 0,
    w: ENV.w, h: ENV.h, dpr: ENV.dpr, mob: ENV.mob, inapp: ENV.inapp,
    net: ENV.net, ram: ENV.ram, cpu: ENV.cpu, tz: ENV.tz, lang: ENV.lang,
    ua: ENV.ua
  });

  /* ---------- perf ------------------------------------------------------- */

  var LCP = null;
  safe(function () {
    new PerformanceObserver(function (l) {
      var e = l.getEntries(); if (e.length) LCP = Math.round(e[e.length - 1].startTime);
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  });

  window.addEventListener('load', function () {
    setTimeout(function () {
      safe(function () {
        var n = (performance.getEntriesByType('navigation') || [])[0];
        if (!n) return;
        send('perf', {
          ttfb: Math.round(n.responseStart),
          dcl: Math.round(n.domContentLoadedEventEnd),
          load: Math.round(n.loadEventEnd),
          dom: Math.round(n.domInteractive),
          lcp: LCP,
          bytes: n.transferSize || null,
          navtype: n.type,
          res: (performance.getEntriesByType('resource') || []).length
        });
      });
    }, 800);
  });

  /* ---------- klikken, rage clicks, dode klikken -------------------------- */

  var clicks = 0, rage = 0, dead = 0, lastEl = null, atcClicked = 0;
  var recent = [];
  var domDirty = false;
  safe(function () {
    new MutationObserver(function () { domDirty = true; }).observe(document.documentElement,
      { childList: true, subtree: true, attributes: true });
  });

  function role(el) {
    var h = '';
    for (var p = el; p && p !== document.body; p = p.parentElement) {
      h += ' ' + (p.className && p.className.baseVal !== undefined ? p.className.baseVal : (p.className || ''));
      h += ' ' + (p.id || '') + ' ' + p.tagName;
      if (p.getAttribute) h += ' ' + (p.getAttribute('name') || '') + ' ' + (p.getAttribute('data-testid') || '');
    }
    h = h.toLowerCase();
    if (/add-to-cart|add_to_cart|"add"|product-form__submit|\badd\b/.test(h) && /button|input|submit/.test(h)) return 'atc';
    if (/checkout/.test(h)) return 'checkout';
    if (/swatch|variant|option/.test(h)) return 'variant';
    if (/size-chart|sizechart|size_chart|maattabel/.test(h)) return 'maattabel';
    if (/gallery|thumb|carousel|slider|zoom|dots/.test(h)) return 'galerij';
    if (/accordion|collaps|summary|details|description/.test(h)) return 'beschrijving';
    if (/review|beoordel/.test(h)) return 'reviews';
    if (/product-card|card__|productitem|grid__item/.test(h)) return 'producttegel';
    if (/cart|winkelwagen|drawer/.test(h)) return 'winkelwagen';
    if (/menu|nav|header/.test(h)) return 'navigatie';
    if (/footer/.test(h)) return 'footer';
    if (/sticky/.test(h)) return 'sticky';
    if (el.closest && el.closest('a')) return 'link';
    if (/button|input|select|label/.test(el.tagName.toLowerCase())) return 'knop';
    return 'overig';
  }

  document.addEventListener('click', function (ev) {
    safe(function () {
      var el = ev.target; if (!el || !el.tagName) return;
      var now = Date.now();

      // rage click: 3+ klikken binnen 700ms in een straal van 30px
      recent.push({ t: now, x: ev.clientX, y: ev.clientY });
      recent = recent.filter(function (r) { return now - r.t < 700; });
      if (recent.length >= 3) {
        var d = recent.every(function (r) {
          return Math.abs(r.x - ev.clientX) < 30 && Math.abs(r.y - ev.clientY) < 30;
        });
        if (d) { rage++; recent = []; send('rage_click', { role: role(el), tag: el.tagName, txt: (el.textContent || '').trim().slice(0, 40) }); }
      }

      // dode klik: geen link/knop, en 500ms later niets veranderd in de DOM
      var interactive = el.closest && el.closest('a,button,input,select,textarea,label,summary,[role="button"],[onclick]');
      if (!interactive) {
        domDirty = false;
        var href0 = location.href;
        setTimeout(function () {
          if (!domDirty && location.href === href0) {
            dead++;
            if (dead <= 5) send('dead_click', { role: role(el), tag: el.tagName, txt: (el.textContent || '').trim().slice(0, 40) });
          }
        }, 500);
      }

      var r = role(el);
      if (r === 'atc') atcClicked = 1;
      lastEl = r;
      if (++clicks > MAX_CLICKS) return;
      send('element_click', {
        role: r, tag: el.tagName,
        cls: String((el.className && el.className.baseVal !== undefined ? el.className.baseVal : el.className) || '').slice(0, 60),
        txt: (el.textContent || '').trim().slice(0, 40),
        xp: Math.round(100 * ev.clientX / Math.max(1, window.innerWidth)),
        yp: Math.round(100 * (ev.clientY + window.scrollY) / Math.max(1, document.documentElement.scrollHeight)),
        n: clicks
      });
    });
  }, true);

  /* ---------- variant ---------------------------------------------------- */

  document.addEventListener('change', function (ev) {
    safe(function () {
      var el = ev.target; if (!el || !el.name) return;
      if (!/option|variant|swatch|size|color|colour/i.test(el.name + ' ' + (el.id || '') + ' ' + (el.className || ''))) return;
      send('variant_change', { name: String(el.name).slice(0, 40), val: String(el.value || '').slice(0, 40) });
    });
  }, true);

  /* ---------- scrolldiepte ----------------------------------------------- */

  var maxScroll = 0, firstInteract = null, t0 = Date.now();
  function markInteract() { if (firstInteract === null) firstInteract = Date.now() - t0; }
  ['click', 'keydown', 'touchstart', 'wheel'].forEach(function (e) {
    window.addEventListener(e, markInteract, { passive: true, capture: true });
  });
  window.addEventListener('scroll', function () {
    safe(function () {
      markInteract();
      var H = Math.max(1, document.documentElement.scrollHeight);
      var p = Math.round(100 * (window.scrollY + window.innerHeight) / H);
      if (p > maxScroll) maxScroll = Math.min(100, p);
    });
  }, { passive: true });

  /* ---------- fotogalerij (zelfde events als v1, bredere selectors) ------- */

  var galMax = 0, galFired = false;
  function galTouch(i) {
    if (typeof i === 'number' && i > galMax) galMax = i;
    if (!galFired) { galFired = true; send('gallery_interact', null, galMax); }
  }
  function initGallery() {
    safe(function () {
      var vp = document.querySelector('.product-gallery__viewport');
      if (vp) {
        var t = null;
        vp.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var w = vp.clientWidth || 1;
            galTouch(Math.max(0, Math.round(vp.scrollLeft / w)));
          }, 140);
        }, { passive: true });
      }
      // breder: thumbnails, dots, zoom, en de variant-carrousel onder de hero
      document.addEventListener('click', function (e) {
        var el = e.target && e.target.closest ? e.target.closest(
          '.product-gallery__zoom, [class*="product-gallery__thumb"], [class*="product-gallery__dot"],' +
          '[class*="thumbnail"], [class*="floating_dots"] button, [class*="media-gallery"] button,' +
          '[class*="slideshow"] button, [class*="carousel"] button, [class*="swatch"]'
        ) : null;
        if (el) galTouch(galMax);
      }, true);
    });
  }

  /* ---------- page_exit: vuurt ALTIJD ------------------------------------ */

  // LET OP: niet permanent afsluiten. iOS vuurt pagehide onbetrouwbaar, dus we
  // gebruiken visibilitychange - maar wie terugkomt naar het tabblad moet later
  // opnieuw kunnen afsluiten, anders meet je alleen tot de eerste keer wegklikken.
  // Neem bij analyse de rij met de hoogste seq per sessie+url.
  var exited = false, seq = 0, activeMs = 0, visSince = Date.now();
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { visSince = Date.now(); exited = false; }
    else if (visSince) { activeMs += Date.now() - visSince; visSince = 0; }
  });

  function exit() {
    if (exited) return; exited = true; seq++;
    var dwell = Date.now() - t0;
    var act = activeMs + (visSince ? Date.now() - visSince : 0);
    var batch = [envelope('page_exit', {
      seq: seq,
      dwell: dwell,
      active: act,
      scroll: maxScroll,
      clicks: clicks,
      rage: rage,
      dead: dead,
      firstint: firstInteract,
      last: lastEl,
      atcclick: atcClicked,
      galmax: galFired ? galMax : null,
      galtouch: galFired ? 1 : 0,
      lcp: LCP,
      hidden: document.visibilityState === 'hidden' ? 1 : 0
    })];
    if (galFired && seq === 1) batch.push(envelope('gallery_depth', null, galMax));
    post(batch, true);
  }
  window.addEventListener('pagehide', exit);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') exit();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGallery);
  else initGallery();
})();
